'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "value", "addPropertiesToDroppedEvent", "lockSurfaceType"];
import * as React from 'react';
import { useRenderElement } from "../../base-ui-copy/utils/useRenderElement.mjs";
import { useCompositeListItem } from "../../base-ui-copy/composite/list/useCompositeListItem.mjs";
import { useAdapterContext } from "../../use-adapter-context/index.mjs";
import { useEventCreation } from "../../internals/utils/useEventCreation.mjs";
import { useDayCellDropTarget } from "./useDayCellDropTarget.mjs";
import { CalendarGridDayCellContext } from "./CalendarGridDayCellContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export const CalendarGridDayCell = /*#__PURE__*/React.forwardRef(function CalendarGridDayCell(componentProps, forwardedRef) {
  const {
      // Rendering props

      // Internal props
      value,
      addPropertiesToDroppedEvent,
      lockSurfaceType
      // Props forwarded to the DOM element
    } = componentProps,
    elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  const adapter = useAdapterContext();
  const {
    ref: listItemRef,
    index
  } = useCompositeListItem();
  const dropTargetRef = useDayCellDropTarget({
    value,
    addPropertiesToDroppedEvent
  });
  const eventCreationProps = useEventCreation(() => ({
    surfaceType: 'day-grid',
    start: adapter.startOfDay(value),
    end: adapter.endOfDay(value),
    lockSurfaceType,
    resourceId: null
  }));
  const props = {
    role: 'gridcell'
  };
  const contextValue = React.useMemo(() => ({
    index
  }), [index]);
  const element = useRenderElement('div', componentProps, {
    ref: [forwardedRef, dropTargetRef, listItemRef],
    props: [props, eventCreationProps, elementProps]
  });
  return /*#__PURE__*/_jsx(CalendarGridDayCellContext.Provider, {
    value: contextValue,
    children: element
  });
});
if (process.env.NODE_ENV !== "production") CalendarGridDayCell.displayName = "CalendarGridDayCell";